import { Outlet } from "react-router-dom";
import TopArea from './TopArea'
import HeaderArea from './HeaderArea'
import BottomArea from './BottomArea';
import SiteStyle from './../Styles/Site.css';

export default function MasterPage() {
  return (
    <div className='allArea'>
      <TopArea />
      <HeaderArea />
      <Outlet />
      <BottomArea />
    </div>
    )
  }